import { useId } from 'react';
import DiagramMotion from './DiagramMotion';
import Reveal from './Reveal';

function ValueDiagram({ type }: { type: 'innovation' | 'automation' | 'stability' }) {
  const id = useId();
  const descriptions = {
    innovation: '現場の課題と技術をつなぎ、検証しながら使える価値をつくる。',
    automation: '繰り返す作業を仕組みに集約し、人が考え、対話する時間へつなぐ。',
    stability: '監視・改善・保守を循環させ、サービスが動き続ける基盤を支える。',
  };
  return <figure className={`value-diagram value-${type}`}>
    <svg viewBox="0 0 360 250" role="img" aria-labelledby={id}>
      <title id={id}>{descriptions[type]}</title>
      {type === 'innovation' && <>
        <circle className="value-disc" cx="135" cy="111" r="70" /><circle className="value-disc value-disc-deep" cx="225" cy="111" r="70" />
        <path className="value-guide" d="M135 111H225M180 125V197" />
        <circle className="value-pulse" cx="180" cy="111" r="24" /><circle className="value-center" cx="180" cy="111" r="16" />
        <path className="value-white-stroke" d="m172 111 6 6 11-13" />
        <text x="107" y="115">課題</text><text x="253" y="115">技術</text>
        <rect className="value-label-box" x="120" y="184" width="120" height="36" rx="18" /><text x="180" y="207">使える価値へ</text>
        <circle className="value-travel-down" cx="180" cy="153" r="4" />
      </>}
      {type === 'automation' && <>
        <path className="value-guide" d="M82 64H120V125H266M82 125H120M82 186H120V125" />
        {[44,105,166].map((y, i) => <g key={y}><rect className="value-task" x="26" y={y} width="62" height="40" rx="8" /><text x="57" y={y+25}>{['入力','転記','集計'][i]}</text></g>)}
        <circle className="value-disc" cx="176" cy="125" r="42" /><circle className="value-pulse" cx="176" cy="125" r="32" />
        <text x="176" y="130">自動化</text>
        <circle className="value-center" cx="285" cy="113" r="16" /><path className="value-person" d="M258 161v-10c0-30 54-30 54 0v10" />
        <text x="285" y="194">人の時間へ</text><circle className="value-travel-across" cx="222" cy="125" r="4" />
      </>}
      {type === 'stability' && <>
        <circle className="value-guide" cx="180" cy="125" r="77" />
        <g className="value-cycle"><circle cx="180" cy="48" r="5" /><circle cx="247" cy="164" r="5" /><circle cx="113" cy="164" r="5" /></g>
        <path className="value-shield" d="M180 80 214 92v35c0 23-34 43-34 43s-34-20-34-43V92Z" /><path className="value-white-stroke" d="m164 123 11 11 22-25" />
        <rect className="value-label-box" x="149" y="28" width="62" height="34" rx="17" /><text x="180" y="50">監視</text>
        <rect className="value-label-box" x="75" y="169" width="62" height="34" rx="17" /><text x="106" y="191">保守</text>
        <rect className="value-label-box" x="223" y="169" width="62" height="34" rx="17" /><text x="254" y="191">改善</text>
      </>}
    </svg>
  </figure>;
}
const values = [
  { type: 'innovation' as const, title: '革新', heading: '新しい価値を、実際の事業へ。', body: '現場の課題と、実現したいことから考えます。AIやソフトウェアの可能性を小さく試し、検証を重ね、お客様が使えるプロダクトと仕組みに育てます。' },
  { type: 'automation' as const, title: '自動化', heading: '人が向き合う仕事に、時間を。', body: '入力・転記・集計など、日々の繰り返しを仕組みへ。業務の流れから見直し、考えること、対話すること、新しい取り組みに使える時間をつくります。' },
  { type: 'stability' as const, title: '安定性', heading: '価値を、届け続けるために。', body: '開発の先にある運用と保守まで見据えて設計します。監視で変化を捉え、改善を重ねながら、安心して使い続けられる事業基盤を支えます。' },
];
export default function CompanyValues() {
  return <section className="corporate-values" aria-labelledby="corporate-values-title"><Reveal><h2 id="corporate-values-title" className="content-heading">大切にしていること</h2><p className="values-intro">新しい価値をつくり、人の時間を生み出し、安定して届け続ける。<br />この3つを、ひとつながりの仕事として考えています。</p></Reveal>
    <DiagramMotion><div className="company-value-grid">{values.map(value => <Reveal key={value.type}><article className="company-value"><ValueDiagram type={value.type} /><h3>{value.title}</h3><h4>{value.heading}</h4><p>{value.body}</p></article></Reveal>)}</div></DiagramMotion>
  </section>;
}
